import { makeStyles } from '@material-ui/core';

import { scrollbar } from '@styles';

export default makeStyles(({ palette: { primary } }) => ({
  '@global': {
    'html, body': {
      height: '100%',
      minHeight: '100%',
      overflowX: 'hidden',
      ...scrollbar(primary),
    },

    /* minHeight (not height) + no overflow-x here: avoids #root becoming the y-scroll box */
    '#root': {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
      margin: 0,
      padding: 0,
    },

    main: {
      flex: '1 0 auto',

      '&::after': {
        content: "'\\00a0'",
        display: 'block',
        height: 0,
        visibility: 'hidden',
      },
    },

    'footer, header': {
      flex: 'none',
    },

    a: {
      color: primary.dark,
    },
  },
}));
